module.exports = __webpack_public_path__ + "static/media/2.808f2fe5.png";